import { render, staticRenderFns } from "./LoadingFragment.vue?vue&type=template&id=56a2e6cc&scoped=true&"
import script from "./LoadingFragment.vue?vue&type=script&lang=js&"
export * from "./LoadingFragment.vue?vue&type=script&lang=js&"
import style0 from "./LoadingFragment.vue?vue&type=style&index=0&id=56a2e6cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2e6cc",
  null
  
)

export default component.exports